module.exports = __webpack_public_path__ + "static/img/作品52.0a6c8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品52.png
// module id = uztz
// module chunks = 1